/* ══════════════════════════════════════
   STORE 03 — ADD TO CART TOAST
   Replaces the auto-opening cart drawer on
   add / quick-add with a lightweight toast +
   button success animation. Mentions the free
   gift only on the add that actually added it.
   Config: window.__cartToast (see cart-toast.liquid)
══════════════════════════════════════ */
(function () {
  const cfg = window.__cartToast || {};
  if (!cfg.enabled) return;

  const DISPLAY_MS = 4500;
  const CHECK_SVG =
    '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M7.6 13.4 4.2 10l-1.2 1.2 4.6 4.6 9-9L15.4 5.6z"/></svg>';
  const GIFT_SVG =
    '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7"/><path d="M12 8S11 3 8.5 3 5.5 5 5.5 5 6 8 12 8Zm0 0s1-5 3.5-5S18.5 5 18.5 5 18 8 12 8Z"/></svg>';
  const CLOSE_SVG =
    '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true"><path fill="currentColor" d="M15 5.7 14.3 5 10 9.3 5.7 5 5 5.7 9.3 10 5 14.3l.7.7L10 10.7l4.3 4.3.7-.7L10.7 10z"/></svg>';

  let currentToast = null;
  let hideTimer = null;
  let lastAddButton = null;

  /* ---------- helpers ---------- */

  function escapeHtml(str) {
    const d = document.createElement('div');
    d.textContent = str == null ? '' : String(str);
    return d.innerHTML;
  }

  function normalize(state) {
    let item = state;
    if (state && Array.isArray(state.items)) item = state.items[0];
    if (!item) return null;
    return {
      title: item.product_title || item.title || 'Item',
      image: item.image || (item.featured_image && item.featured_image.url) || null,
      quantity: item.quantity || 1,
      url: item.url || null,
    };
  }

  function region() {
    let r = document.getElementById('CartToast');
    if (!r) {
      r = document.createElement('div');
      r.id = 'CartToast';
      r.className = 'cart-toast-region';
      r.setAttribute('aria-live', 'polite');
      document.body.appendChild(r);
    }
    return r;
  }

  function buildToast() {
    const t = document.createElement('div');
    t.className = 'cart-toast';
    t.setAttribute('role', 'status');
    t.innerHTML =
      '<button type="button" class="cart-toast__close" aria-label="Close">' + CLOSE_SVG + '</button>' +
      '<div class="cart-toast__inner">' +
      '<div class="cart-toast__body"></div>' +
      '<div class="cart-toast__gift" hidden></div>' +
      '<div class="cart-toast__actions">' +
      '<button type="button" class="cart-toast__btn cart-toast__btn--secondary" data-action="view">View cart</button>' +
      '<a class="cart-toast__btn cart-toast__btn--primary" href="' + (cfg.checkoutUrl || '/checkout') + '">Checkout</a>' +
      '</div>' +
      '</div>';

    t.querySelector('.cart-toast__close').addEventListener('click', () => hide());
    t.querySelector('[data-action="view"]').addEventListener('click', () => {
      hide();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        window.location = cfg.cartUrl || '/cart';
      }
    });
    return t;
  }

  function ensureToast() {
    if (!currentToast) {
      currentToast = buildToast();
      region().appendChild(currentToast);
    }
    return currentToast;
  }

  function bodyMarkup(item) {
    const media = item.image
      ? '<div class="cart-toast__media"><img src="' + escapeHtml(item.image) + '" alt="" loading="lazy"></div>'
      : '';
    const qty = item.quantity > 1 ? '<span class="cart-toast__qty">Qty ' + item.quantity + '</span>' : '';
    return (
      media +
      '<div class="cart-toast__text">' +
      '<span class="cart-toast__label">' + CHECK_SVG + '<span>Added to cart</span></span>' +
      '<span class="cart-toast__title">' + escapeHtml(item.title) + '</span>' +
      qty +
      '</div>'
    );
  }

  function giftMarkup(title) {
    return (
      '<span class="cart-toast__gift-icon">' + GIFT_SVG + '</span>' +
      '<span class="cart-toast__gift-text"><strong>Free gift added</strong>' +
      escapeHtml(title) + '</span>'
    );
  }

  function show(el) {
    el.classList.remove('is-leaving');
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, DISPLAY_MS);
  }

  function hide() {
    if (!currentToast) return;
    const el = currentToast;
    clearTimeout(hideTimer);
    el.classList.remove('is-visible');
    el.classList.add('is-leaving');
    el.addEventListener(
      'transitionend',
      () => {
        if (el.parentNode) el.parentNode.removeChild(el);
        if (currentToast === el) currentToast = null;
      },
      { once: true }
    );
  }

  function isVisible(el) {
    return el && el.classList.contains('is-visible');
  }

  function bumpCart() {
    const c = document.getElementById('cart-icon-bubble');
    if (!c) return;
    c.classList.remove('cart-bump');
    void c.offsetWidth; // restart animation
    c.classList.add('cart-bump');
    setTimeout(() => c.classList.remove('cart-bump'), 700);
  }

  function flashButton() {
    const btn = lastAddButton;
    lastAddButton = null;
    if (!btn || !btn.isConnected) return;
    // Skip the "choose options" quick-add opener — it doesn't add to cart.
    if (btn.getAttribute('aria-haspopup') === 'dialog') return;
    btn.classList.add('cart-btn-added');
    setTimeout(() => btn.classList.remove('cart-btn-added'), 1600);
  }

  /* ---------- toast triggers ---------- */

  function showAdd(state) {
    const item = normalize(state);
    if (!item) return;
    const el = ensureToast();
    el.querySelector('.cart-toast__body').innerHTML = bodyMarkup(item);
    const gift = el.querySelector('.cart-toast__gift');
    gift.hidden = true; // reset — the gift only rides along when free-gift fires
    gift.innerHTML = '';
    show(el);
    flashButton();
  }

  document.addEventListener('free-gift:added', (e) => {
    const title = (e.detail && e.detail.title) || 'Free gift';
    const el = ensureToast();
    const gift = el.querySelector('.cart-toast__gift');
    gift.innerHTML = giftMarkup(title);
    gift.hidden = false;
    show(el);
  });

  // Remember which button initiated the add so we can animate it on success.
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest(
        '.product-form__submit, .quick-add__submit, product-form button[type="submit"]'
      );
      if (btn) lastAddButton = btn;
    },
    true
  );

  /* ---------- suppress drawer auto-open, hand off to toast ---------- */

  function patchDrawer() {
    const CartDrawer = window.customElements && customElements.get('cart-drawer');
    if (!CartDrawer || CartDrawer.prototype.__toastPatched) return true;

    CartDrawer.prototype.renderContents = function (parsedState) {
      const inner = this.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      this.classList.remove('is-empty');
      this.productId = parsedState.id;

      this.getSectionsToRender().forEach((section) => {
        const el = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!el || !parsedState.sections || !parsedState.sections[section.id]) return;
        el.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });

      // Keep the overlay's close-on-click working, but do NOT auto-open.
      setTimeout(() => {
        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));
      });

      bumpCart();
      showAdd(parsedState);
    };

    CartDrawer.prototype.__toastPatched = true;
    return true;
  }

  function initPatch(tries) {
    tries = tries || 0;
    if (patchDrawer()) return;
    if (tries < 50) setTimeout(() => initPatch(tries + 1), 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPatch());
  } else {
    initPatch();
  }
})();
